/**
 * Desi Firms Design System - Shadow Tokens
 * Elevation system for depth and hierarchy
 */

export const shadows = {
  none: 'none',

  // Subtle shadows for cards and containers
  xs: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  sm: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)',

  // Default shadow for interactive elements
  default: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',

  // Elevated shadows for dropdowns, modals
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
  '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',

  // Inner shadow for inputs
  inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)',

  // Focus ring shadow (for accessibility)
  focus: '0 0 0 3px rgba(0, 147, 233, 0.4)',
  focusError: '0 0 0 3px rgba(220, 38, 38, 0.4)',
  focusSuccess: '0 0 0 3px rgba(72, 187, 120, 0.4)',

  // Card hover state
  cardHover: '0 10px 40px -10px rgba(0, 147, 233, 0.2)',

  // Premium/featured cards
  premium: '0 10px 40px -10px rgba(128, 90, 213, 0.3)',

  // Colored shadows for brand elements
  primary: '0 4px 14px 0 rgba(0, 147, 233, 0.4)',
  primaryLg: '0 10px 30px 0 rgba(0, 147, 233, 0.3)',
  success: '0 4px 14px 0 rgba(72, 187, 120, 0.4)',
  error: '0 4px 14px 0 rgba(220, 38, 38, 0.4)',
  warning: '0 4px 14px 0 rgba(245, 158, 11, 0.4)',
};

// Elevation levels (semantic)
export const elevation = {
  // Ground level - no shadow
  0: shadows.none,

  // Slightly raised - subtle cards, sections
  1: shadows.xs,

  // Raised - cards, list items
  2: shadows.sm,

  // Floating - buttons on hover, floating action buttons
  3: shadows.default,

  // High - dropdowns, popovers, tooltips
  4: shadows.lg,

  // Highest - modals, dialogs, drawers
  5: shadows.xl,

  // Maximum - full-screen overlays
  6: shadows['2xl'],
};

// Z-index scale
export const zIndices = {
  hide: -1,
  auto: 'auto',
  base: 0,
  docked: 10,
  dropdown: 1000,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800,
};

export default {
  shadows,
  elevation,
  zIndices,
};
